import loadable from '@loadable/component'

import { DRAWER_MENU_CATEGORIES, DRAWER_MENU_KEYS } from '~/config/_idm'

const Organization = loadable(
  () =>
    import('~/pages/_IDM/Organization') /* webpackChunkName: "Organization" */
)
const Settings = loadable(
  () => import('~/pages/_IDM/Settings')
) /* webpackChunkName: "Settings" */

const Role = loadable(
  () => import('~/pages/_IDM/Role')
) /* webpackChunkName: "Role" */

const User = loadable(
  () => import('~/pages/_IDM/User')
) /* webpackChunkName: "User" */

const Group = loadable(
  () => import('~/pages/_IDM/Group')
) /* webpackChunkName: "Group" */

const AuditLog = loadable(
  () => import('~/pages/_IDM/AuditLog')
) /* webpackChunkName: "AuditLog" */

export default [
  {
    id: DRAWER_MENU_KEYS.ORGANIZATION,
    title: 'Organization',
    path: '/organization/:type',
    defaultPath: '/organization',
    component: Organization,
    exact: true,
    disabled: false,
    shownOnMenu: true,
    shownOnTab: true,
    withHeader: true,
    userAccess: false,
    clientAdminAccess: true,
    sysAdminAccess: true,
    category: DRAWER_MENU_CATEGORIES.MANAGEMENT,
    icon: '/public/icons/menu-icon/profile.svg',
    hideTab: false,
  },
  {
    id: DRAWER_MENU_KEYS.SETTING,
    title: 'Settings',
    path: '/settings/:type',
    defaultPath: '/settings/profile',
    component: Settings,
    exact: true,
    disabled: false,
    shownOnMenu: true,
    withHeader: true,
    userAccess: true,
    clientAdminAccess: true,
    sysAdminAccess: true,
    category: DRAWER_MENU_CATEGORIES.SETTING,
    icon: '/public/icons/menu-icon/profile.svg',
    shownOnTab: false,
    hideTab: true,
  },
  {
    id: DRAWER_MENU_KEYS.ROLE,
    title: 'Roles',
    path: '/role/:type',
    defaultPath: '/role/list',
    component: Role,
    exact: true,
    disabled: false,
    shownOnMenu: false,
    withHeader: true,
    userAccess: false,
    clientAdminAccess: true,
    sysAdminAccess: false,
    category: DRAWER_MENU_CATEGORIES.ACCESS,
    icon: '',
    shownOnTab: true,
    hideTab: false,
  },
  {
    id: 'user',
    title: 'Users',
    path: '/user/:type',
    defaultPath: '/user/list',
    component: User,
    exact: true,
    disabled: false,
    shownOnMenu: false,
    withHeader: true,
    userAccess: false,
    clientAdminAccess: true,
    sysAdminAccess: true,
    category: DRAWER_MENU_CATEGORIES.MANAGEMENT,
    icon: '',
    shownOnTab: true,
    hideTab: false,
  },
  {
    id: 'group',
    title: 'Groups',
    path: '/group/:type',
    defaultPath: '/group/list',
    component: Group,
    exact: true,
    disabled: false,
    shownOnMenu: false,
    withHeader: true,
    userAccess: false,
    clientAdminAccess: true,
    sysAdminAccess: false,
    category: DRAWER_MENU_CATEGORIES.MANAGEMENT,
    icon: '',
    shownOnTab: true,
    hideTab: false,
  },
  {
    id: 'audit-log',
    title: 'Audit Log',
    path: '/audit-log',
    defaultPath: '/audit-log',
    component: AuditLog,
    exact: true,
    disabled: false,
    shownOnMenu: false,
    withHeader: true,
    userAccess: false,
    clientAdminAccess: true,
    sysAdminAccess: false,
    category: DRAWER_MENU_CATEGORIES.REPORT,
    icon: '',
    shownOnTab: true,
    hideTab: false,
  },
]
